import { render, staticRenderFns } from "./TimeTablesDetailView.vue?vue&type=template&id=15db6e93"
import script from "./TimeTablesDetailView.vue?vue&type=script&lang=js"
export * from "./TimeTablesDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports